/** @format */

import React, { useEffect, useState } from "react";
import HOC from "../../layout/HOC";
import {
  Table,
  Alert,
  Modal,
  Form,
  Spinner,
  Button,
  Badge,
} from "react-bootstrap";
import axios from "axios";
import { showMessage } from "../../../Component/Message";

const AdminOrder = () => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [id, setId] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const token = localStorage.getItem("token");
  const Auth = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        `${process.env.React_App_BASEURL}api/v1/order/admin/orders`,
        Auth
      );
      setData(data.orders?.reverse());
      setTotal(data.orders.length);
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  function MyVerticallyCenteredModal(props) {
    const [orderStatus, setOrderStatus] = useState(null);
    const [errMsg, setErrMsg] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);

    const SubmitHandler = async (e) => {
      e.preventDefault();
      setSubmitLoading(true);
      try {
        const { data } = await axios.put(
          `${process.env.React_App_BASEURL}api/v1/order/admin/${id}`,
          { status: orderStatus },
          Auth
        );
        const msg = data?.message;
        showMessage("Success", msg, "success");
        setSubmitLoading(false);
        props.onHide();
        fetchData();
      } catch (e) {
        setSubmitLoading(false);
        const msg = e.response.data.message;
        setErrMsg(msg);
      }
    };

    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Order Status
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errMsg === null || !errMsg ? (
            ""
          ) : (
            <div className="dangerBox">
              <Alert variant="danger"> {errMsg} </Alert>
              <i class="fa-solid fa-x" onClick={() => setErrMsg(null)}></i>
            </div>
          )}

          <Form onSubmit={SubmitHandler}>
            <Form.Group className="mb-3">
              <Form.Label>Select Status</Form.Label>
              <Form.Select onChange={(e) => setOrderStatus(e.target.value)}>
                <option> </option>
                <option value="signed">Signed</option>
                <option value="processed">Processed</option>
                <option value="shipped">Shipped</option>
                <option value="out_for_delivery">Out For Delivery</option>
                <option value="delivered">Delivered</option>
              </Form.Select>
            </Form.Group>

            <Button
              style={{
                backgroundColor: "#0c0c0c",
                borderRadius: "0",
                border: "1px solid #0c0c0c",
              }}
              type="submit"
            >
              {submitLoading === true ? (
                <Spinner size="sm" animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              ) : (
                "Submit"
              )}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }

  const filterData = !search
    ? data
    : data?.filter(
        (i) =>
          i?.user?.name?.toLowerCase().includes(search?.toLowerCase()) ||
          i?.status?.toLowerCase().includes(search?.toLowerCase())
      );

  return (
    <>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <section>
        <section className="sectionCont">
          <div className="pb-4   w-full flex justify-between items-center">
            <span
              className="tracking-widest text-slate-900 font-semibold uppercase"
              style={{ fontSize: "1.2rem" }}
            >
              All Orders ( Total : {total} )
            </span>
          </div>

          <div className="filterBox">
            <img
              src="https://t4.ftcdn.net/jpg/01/41/97/61/360_F_141976137_kQrdYIvfn3e0RT1EWbZOmQciOKLMgCwG.jpg"
              alt=""
            />
            <input
              type="search"
              placeholder="Search by User || Status"
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {loading ? (
            <Spinner animation="border" role="status" className="loadingSpin" />
          ) : data?.length === 0 || !data ? (
            <Alert>Order Not Found</Alert>
          ) : (
            <>
              <div className="overFlowCont">
                <Table>
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>User</th>
                      <th>Amount To Be Paid</th>
                      <th>Delivered</th>
                      <th>Discount</th>
                      <th>Grand Total</th>
                      <th> Status</th>
                      <th>Shipping Price</th>
                      <th>Product</th>
                      <th>Status</th>
                      <th>Created At</th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>
                    {filterData?.map((i, index) => (
                      <tr key={index}>
                        <td>#{index + 1} </td>
                        <td> {i.user?.name} </td>
                        <td> ₹{i.amountToBePaid} </td>
                        <td>
                          {" "}
                          {i.delivered === false
                            ? "Not Delivered"
                            : "delivered"}{" "}
                        </td>
                        <td> {i.discount} </td>
                        <td> ₹{i.grandTotal} </td>
                        <td> {i.status} </td>
                        <td> ₹{i.shippingPrice} </td>
                        <td>
                          <ul style={{ listStyle: "disc" }}>
                            {i.products?.map((i, index) => (
                              <li key={index}> {i.product?.name} </li>
                            ))}
                          </ul>
                        </td>
                        <td>
                          <Badge> {i.status} </Badge>
                        </td>
                        <td> {i.createdAt?.substr(0, 10)} </td>
                        <td>
                          <span className="flexCont">
                            <i
                              className="fa-solid fa-pen-to-square"
                              onClick={() => {
                                setId(i._id);
                                setModalShow(true);
                              }}
                            ></i>
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </>
          )}
        </section>
      </section>
    </>
  );
};

export default HOC(AdminOrder);
